import { render, staticRenderFns } from "./prpCategoryForm.vue?vue&type=template&id=a161c46e"
import script from "./prpCategoryForm.vue?vue&type=script&lang=js"
export * from "./prpCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports